import { validateFrenchDateBeforeToday } from '@/helpers'

const beforeTodayValidator = (value) => {
  return validateFrenchDateBeforeToday(value)
}

export default beforeTodayValidator
